<template>
  <v-container
    id="extended-forms"
    fluid
    tag="section"
  >
    <validation-observer v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submitForm)">
        <v-row>
          <v-col cols="12">
            <base-material-card
              class="pa-6"
              color="success"
              icon="mdi-tag-outline"
              :title="title"
            >
              <v-skeleton-loader
                class="mx-auto"
                max-width="300"
                type="card"
                :loading="loadingProductCategory"
              >
                <v-row
                  style="display: flex;
                        align-items: center;
                        justify-content: center;"
                >
                  <v-col
                    cols="6"
                    md="6"
                  >
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required|max:50"
                          name="productCategory.name"
                        >
                          <v-text-field
                            v-model="productCategory.name"
                            :error-messages="errors"
                            color="secondary"
                            :label="$t('fields.productCategory.name')"
                            outlined
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col
                    cols="3"
                    class="text-center"
                  >
                    <input
                      ref="file"
                      type="file"
                      class="d-none"
                      @change="selectImage"
                    >
                    <v-card
                      :class="productCategory.singleImage ? 'success--text' : 'grey--text'"
                      class="mx-auto mt-0 d-inline-flex v-card--account"
                      outlined
                      height="160"
                      width="160"
                      @click="$refs.file.click()"
                    >
                      <v-img
                        v-if="productCategory.singleImage"
                        :src="productCategory.singleImage"
                        height="100%"
                        width="100%"
                      />
                      <v-icon
                        v-else
                        class="mx-auto"
                        size="96"
                      >
                        mdi-image
                      </v-icon>
                    </v-card>
                    <div class="font-weight-bold grey--text">
                      Imagen de categoría
                    </div>
                  </v-col>
                  <v-col
                    cols="3"
                    class="text-center"
                  >
                    <div
                      id="my-strictly-unique-vue-upload-multiple-image"
                      style="display: flex; justify-content: center;"
                    >
                      <vue-upload-multiple-image
                        drag-text="Arrastra las imágenes"
                        browse-text="o click para seleccionar"
                        primary-text="Por defecto"
                        mark-is-primary-text="Establecer por defecto"
                        popup-text="Esta imagen se mostrará por defecto"
                        drop-text="Deja tus archivos aquí..."
                        :data-images="sliders"
                        @upload-success="uploadImageSuccess"
                        @before-remove="beforeRemove"
                        @edit-image="editImage"
                        @data-change="dataChange"
                        @mark-is-primary="markPrimary"
                      />
                    </div>
                    <div class="font-weight-bold grey--text">
                      Imagenes de cabecera
                    </div>
                  </v-col>
                </v-row>
                <div class="pa-3 text-center">
                  <v-btn
                    color="warning"
                    default
                    @click="goToList"
                  >
                    {{ $t("cancel") }}
                  </v-btn>
                  <v-btn
                    color="success"
                    default
                    type="submit"
                    :loading="loadingSave"
                  >
                    {{ $t("save") }}
                  </v-btn>
                </div>
              </v-skeleton-loader>
            </base-material-card>
          </v-col>
        </v-row>
      </form>
    </validation-observer>

    <product-subCategory-list
      v-if="formAction == 'modify' && !!productCategory.id"
      :product-category-id="productCategory.id"
    />

    <base-material-snackbar
      v-model="showErrorMessage"
      type="error"
      v-bind="{
        ['top']: true,
        ['center']: true,
        ['vertical']: true
      }"
    >
      {{ errorMessage }}
    </base-material-snackbar>
  </v-container>
</template>

<script>
  import VueUploadMultipleImage from 'vue-upload-multiple-image'
  import productSubCategoryList from './ProductSubCategoryList'
  import { repositoryFactory } from '@/api/repositoryFactory'
  const productCategoriesRepository = repositoryFactory.get('productCategories')

  export default {
    inject: ['theme'], // ??
    name: 'ProductCategoryCrud',
    components: { VueUploadMultipleImage, productSubCategoryList },
    $_veeValidate: {
      validator: 'new',
    },
    data: () => ({
      sliders: [],
      sliderBytes: null,
      productCategory: { singleImage: null },
      imageBytes: null,
      productCategoryStatuses: [],
      showErrorMessage: false,
      errorMessage: '',
      loadingProductCategory: false,
      formAction: null,
      loadingSave: false,
    }),
    computed: {
      title () {
        return this.formAction === 'add'
          ? this.$t('add-productCategory')
          : this.$t('modify-productCategory')
      },
    },
    mounted () {
      var self = this
      self.formAction = this.$route.params.id === 'add' ? 'add' : 'modify'

      if (self.formAction !== 'add') {
        self.loadingProductCategory = true
        var id = this.$route.params.id
        productCategoriesRepository
          .getByIdForEdit(id)
          .then(response => {
            self.loadingProductCategory = false
            self.productCategory = Object.assign({}, response.data.data)
            if (self.productCategory.categoryImage.length > 0) {
              console.log('imagesFromApi', self.productCategory.categoryImage)
              self.sliders = self.productCategory.categoryImage
            }
            this.$forceUpdate()
          })
          .catch(err => {
            self.loadingProductCategory = false
            alert(err)
          })
      }
      console.log(this.productCategory)
    },
    methods: {
      // images
      uploadImageSuccess (formData, index, fileList) {
        console.log('uploadImagesSuccess', formData, index, fileList)
        console.log('fileList', fileList)
        console.log('sliders', this.sliders)
        this.sliderBytes = fileList
        console.log('sliderBytes', this.sliderBytes)
      // Upload image api
      // axios.post('http://your-url-upload', { data: formData }).then(response => {
      //   console.log(response)
      // })
      },
      beforeRemove (index, done, fileList) {
        console.log('index', index, fileList)
        var r = confirm('¿Eliminar Imagen?')
        if (r === true) {
          this.sliderBytes = fileList
          console.log('sliderBytes remove', this.sliderBytes)
          done()
        } else {
        }
      },
      editImage (formData, index, fileList) {
        console.log('edit data', formData, index, fileList)
        this.sliderBytes = fileList
        console.log('sliderBytes edited', this.sliderBytes)
      },
      dataChange (data) {
        console.log('data change', data)
      },
      markPrimary (index, fileList) {
        console.log('markPrimary', fileList)
        this.sliderBytes = fileList
      },
      // images-end
      selectImage (val) {
        var self = this
        const value = val.target.files[0]
        if (!value) return (self.productCategory.singleImage = null)
        self.productCategory.singleImage = URL.createObjectURL(value)
        self.imageBytes = value
      },
      submitForm (scope) {
        var self = this
        // var data = {
        //   data: this.productCategory,
        // }
        var data = new FormData()
        data.append('data', JSON.stringify(this.productCategory))
        if (this.imageBytes != null) {
          data.append('imageBytes', this.imageBytes, this.imageBytes.name)
        } else {
          data.append('imageBytes', null)
        }
        if (this.sliderBytes != null) {
          data.append('sliderBytes', JSON.stringify(this.sliderBytes))
        } else {
          data.append('sliderBytes', this.sliders ? JSON.stringify(this.sliders) : null)
        }

        self.loadingSave = true
        if (self.formAction !== 'add') {
          productCategoriesRepository
            .updateProductCategory(data, this.productCategory.id)
            .then(response => {
              if (response.data.isValid) {
                self.goToList()
              } else {
                self.showErrorMessage = true
                self.errorMessage = response.data.errorMessages[0]
              }
              self.loadingSave = false
            })
            .catch(err => {
              self.errorMessage = err
              self.showErrorMessage = true
              self.loadingSave = true
            })
        } else {
          productCategoriesRepository
            .addProductCategory(data)
            .then(response => {
              if (response.data.isValid) {
                self.goToList()
                self.formAction = 'modify'
              } else {
                self.showErrorMessage = true
                self.errorMessage = response.data.errorMessages[0]
              }
              self.loadingSave = false
            })
            .catch(err => {
              self.errorMessage = err
              self.showErrorMessage = true
              self.loadingSave = false
            })
        }
      },
      goToList () {
        this.$router.push({ name: 'productCategories' })
      },
    },
  }
</script>
